import React from 'react';
import { Switch, Route } from 'react-router-dom';
import ListadoCompromisos from './pages/ListadoCompromisos/index';
import CrearCompromiso from './pages/CrearCompromiso/InformacionSolicitante';
import LineasNegocio from './pages/CrearCompromiso/LineasNegocio';
import DatosNegocio from './pages/CrearCompromiso/DatosNegocio';
import InformacionCompromiso from './pages/CrearCompromiso/InformacionCompromiso';


const CompromisosRoutes = ({ ProtectedRouteLogin, HomePublicaLayout, userIsLoggedIn }) => {
  return (
    <Switch>
      <ProtectedRouteLogin
        exact={true}
        path='/compromisos/listado'
        loggedIn={userIsLoggedIn}
        component={ListadoCompromisos}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />

      <ProtectedRouteLogin
        exact={true}
        path='/compromisos/crear'
        loggedIn={userIsLoggedIn}
        component={CrearCompromiso}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        exact={true}
        path='/compromisos/crear/lineas-negocio'
        loggedIn={userIsLoggedIn}
        component={LineasNegocio}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        exact={true}
        path='/compromisos/crear/datos-negocio'
        loggedIn={userIsLoggedIn}
        component={DatosNegocio}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        exact={true}
        path='/compromisos/crear/informacion-compromiso'
        loggedIn={userIsLoggedIn}
        component={InformacionCompromiso}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />

    </Switch>
  );
};

export default CompromisosRoutes;
